import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import '../pages/FooterStuhia.css';

const SiteFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer-stuhia">
      <div className="footer-main">
        <div className="footer-col">
          <div className="footer-logo">Fletaime</div>
          <div style={{ marginBottom: '16px', fontWeight: 600 }}>{t('footer.contact')}</div>
          <div style={{ marginBottom: '8px' }}>Whatsapp +383 45 937 644</div>
          <div>fletaimecom@gmail.com</div>
          <div className="footer-socials" style={{ marginTop: '24px' }}>
            <a href="https://www.instagram.com/fletaime/?hl=en" target="_blank" rel="noreferrer" aria-label="Instagram">Instagram</a>
            <a href="https://www.tiktok.com/@fletaime.com" target="_blank" rel="noreferrer" aria-label="TikTok">Tik Tok</a>
          </div>
        </div>
        <div className="footer-col">
          <div className="footer-title">{t('footer.policiesTitle')}</div>
          <div className="footer-links">
            <a href="#">{t('footer.terms')}</a>
            <Link to="/privacy-policy">{t('footer.privacy')}</Link>
            <a href="#">{t('footer.legal')}</a>
            <Link to="/return-policy">{t('footer.returns')}</Link>
            <a href="#">{t('footer.shippingPolicy')}</a>
            <Link to="/contact">{t('footer.contact')}</Link>
          </div>
        </div>
        <div className="footer-col footer-newsletter">
          <div className="footer-title">{t('footer.newsletterTitle')}</div>
          <div className="newsletter-desc">{t('footer.newsletterDesc')}</div>
          <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder={t('footer.emailPlaceholder')} required />
            <button type="submit" aria-label={t('footer.subscribe')}>→</button>
          </form>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-copyright">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
